// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","message":"App_message__c5-q2"};